import { render, staticRenderFns } from "./NixiaVideoPreviewModal.vue?vue&type=template&id=7d986fa6&scoped=true&"
import script from "./NixiaVideoPreviewModal.vue?vue&type=script&lang=js&"
export * from "./NixiaVideoPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./NixiaVideoPreviewModal.vue?vue&type=style&index=0&id=7d986fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d986fa6",
  null
  
)

export default component.exports